<template>
  <div>
    <el-dialog 
      :title="title"
      :visible.sync="isShown"
      :modal-append-to-body="false" 
      :close-on-click-modal="false"
      v-loading="isLoading">
      <el-form :model="form">
        <el-form-item label="部門名称" :label-width="formLabelWidth" :error="errors.name">
          <el-input
            v-model="form.name"
            auto-complete="off"
            placeholder="部門名称">
          </el-input>
        </el-form-item>
        <el-form-item label="コード" :label-width="formLabelWidth" :error="errors.code">
          <el-input
            v-model="form.code"
            auto-complete="off"
            placeholder="コード">
          </el-input>
        </el-form-item>
        <el-form-item label="一時停止" :label-width="formLabelWidth" :error="errors.isActive">
          <el-switch
            v-model="form.isActive"
            active-color="#A9DFFA"
            inactive-color="#C1C4C6">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShown = false">キャンセル</el-button>
        <el-button size="mini" type="success" @click="submit">{{ createMode ? '登録' : '更新' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DepartmentDialog',
  data () {
    const formDefaultValue = {
      pk: null,
      slug: null,
      name: '',
      code: '',
      isActive: true,
      listOrder: 0,
    }
    return {
      isShown: false,
      isLoading: false,
      form: {...formDefaultValue},
      formDefaultValue: formDefaultValue,
      errors: {
        name: '',
        code: '',
        isActive: '',
      },
      formLabelWidth: '120px',
    }
  },
  computed: {
    createMode () {
      // true: 新規作成 / false: 編集
      return !this.form.slug
    },
    title () {
      return this.createMode ? '新規追加' : '編集'
    },
  },
  methods: {
    show (createMode, data) {
      this.reset()
      if (createMode) {
        this.form.listOrder = data.listOrder
      } else {
        this.form = {...data}
      }
      this.isShown = true
    },
    hide () {
      this.isShown = false
      this.reset()
    },
    reset () {
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = ''
      })
      this.form = {...this.formDefaultValue}
    },
    submit () {
      this.isLoading = true
      let data = {...this.form}
      let api
      if (this.createMode) {
        delete data['slug']
        api = this.$request.departments.addDepartment(data)
      } else {
        api = this.$request.departments.editDepartment(data)
      }

      api.then(res => {
        this.$message({
          message: this.createMode ? '登録しました。' : '更新しました。',
        })
        if (this.createMode) {
          this.$emit('submitted', ['add', res.body])
        } else {
          this.$emit('submitted', ['edit', res.body])
        }
        this.hide()
        return null
      }, err => {
        const body = err.response.body
        this.$parent.$parent.$emit('requestError', [body, this.errors])
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.el-input,
.el-select,
.el-input-number
  width: 300px
</style>



// WEBPACK FOOTER //
// src/components/Department/Dialog.vue